import React from 'react';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';

/**
 * SortableColumn - Wrapper that makes a column sortable with dnd-kit
 * 
 * IMPORTANT: We always render the children to avoid React update loops.
 * When dragging, we hide the children with CSS and show a placeholder overlay.
 */
const SortableColumn = ({ id, children, disabled = false }) => {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ 
    id,
    disabled,
    data: {
      type: 'column',
      columnId: id,
    },
  });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition: transform ? transition : 'none',
  };

  return (
    <div 
      ref={setNodeRef} 
      style={style} 
      className={`sortable-column-wrapper ${isDragging ? 'sortable-column-wrapper--dragging' : ''}`}
      {...attributes}
    >
      {/* Placeholder - always rendered, shown/hidden via CSS */}
      <div className="sortable-column-placeholder" />
      
      {/* Always render children - the content determines the wrapper size */}
      <div className="sortable-column-content">
      {React.cloneElement(children, { 
        dragListeners: listeners,
        isDraggingColumn: isDragging,
      })}
      </div>
    </div>
  );
};

export default SortableColumn;
